import { cn } from "@omni/utils/styles";

import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { PromotionPeriod } from "@/components/Product/PromotionPeriod/promotionPeriod.container";

const PromotionPeriodContainer = () => {
    const { isBoxArticle, salesIncentives, promotions } = useECommerceProduct();
    return (
        <>
            {!isBoxArticle && (
                <PromotionPeriod
                    salesIncentives={salesIncentives}
                    promotions={promotions}
                    className={cn("tw:flex tw:flex-wrap")}
                />
            )}
        </>
    );
};

export { PromotionPeriodContainer };
